import {useQuery} from 'react-query';

import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import {PartnersResponse} from '~types/Partner';

export default function useFetchPartners(enabled?: boolean) {
    const {apiGet} = useFetch();

    return useQuery(
        [ApiEndpoints.Partners],
        () => apiGet<PartnersResponse>(ApiEndpoints.Partners),
        {
            refetchOnWindowFocus: false,
            retry: 1,
            retryDelay: 5 * 1000,
            cacheTime: 1000 * 60 * 60 * 6,
            staleTime: Infinity,
            enabled: enabled,
        },
    );
}
